import React, { useState, useEffect } from "react";
import "./post.css";
import { db, auth } from "../service/firebase";
import firebase from "firebase";
import { Avatar } from "@material-ui/core";
import { faTrash, faComments } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";

function Post({ commentId, id, username, caption, postImage }) {
  const [displayComments, setDisplayComments] = useState([]);
  const [comment, setComment] = useState("");

  const [user, setUser] = useState(null);

  useEffect(() => {
    auth.onAuthStateChanged(function (authUser) {
      if (authUser) {
        // User is signed in.
        setUser(authUser);
      } else {
        // No user is signed in.
        setUser(null);
      }
    });
  }, []);

  const userDetails = user?.displayName === username;

  useEffect(() => {
    let unsubscribe;
    if (commentId) {
      unsubscribe = db
        .collection("posts")
        .doc(commentId)
        .collection("comments")
        .orderBy("timestamp", "asc")
        .onSnapshot((snapshot) => {
          setDisplayComments(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              com: doc.data(),
            }))
          );
        });
    }
    return () => {
      unsubscribe();
    };
  }, [commentId]);

  const commentsCount = displayComments.length;

  const [userDet, setUserDet] = useState({});
  useEffect(() => {
    db.collection("users")
      .doc(username)
      .get()
      .then((doc) => {
        setUserDet(doc.data());
      });
  }, [userDet, username]);
  const userNam = userDet?.user;
  const userPic = userDet?.profileImg;
  const isPic = userNam === username;

  const commentScroll = document.getElementById("commentScroll");

  const postComment = (e) => {
    e.preventDefault();

    db.collection("posts").doc(commentId).collection("comments").add({
      username: user.displayName,
      mes: comment,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });

    setComment("");
    commentScroll.scrollTo({
      top: commentScroll.scrollHeight,
      behavior: "smooth",
    });
  };

  const deletePost = (e) => {
    e.preventDefault();

    db.collection("posts")
      .doc(commentId)
      .delete()
      .then(function () {
        toast.success("Post Deleted");
      })
      .catch(function (error) {
        console.log(error.message);
      });
  };

  return (
    <div className="m-2 mb-4 post">
      <div className="card p-1 border-2" style={{ width: "100%" }}>
        <div className="d-flex align-items-center p-2">
          <Avatar
            className="mr-2 avatar"
            alt="..."
            src={isPic ? userPic : ""}
          />
          <strong>{username}</strong>
        </div>
        <img
          src={postImage}
          className="card-img-top postImg"
          data-toggle="modal"
          data-target={`#${id}`}
          alt="..."
        ></img>
        <div className="card-body">
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon={faComments} className="mb-2" />
            <p className="ml-2 mb-2"> {commentsCount} </p>
          </div>
          <p className="card-text d-flex align-items-center">
            <strong className="mr-1"> {username} </strong>
            {caption}
          </p>
          {userDetails ? (
            <button
              type="button"
              className="btn btn-danger text-right"
              onClick={deletePost}
            >
              Delete
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
      <small id="passwordHelpBlock" className="form-text text-muted">
        Click on the image to comment...
      </small>

      <div
        className="modal fade"
        id={id}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {" "}
                {username}{" "}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" id="commentScroll">
              <div>
                <img
                  alt="post"
                  src={postImage}
                  className="card-img-top w-75"
                ></img>
              </div>
              <div>
                {displayComments.map(({ id, com }) => (
                  <>
                    <h6 className="mt-2">
                      {com.username}
                      <small className="text-muted ml-3"> {com.mes} </small>
                      {user?.displayName === com.username ? (
                        <FontAwesomeIcon
                          className="ml-5 text-danger"
                          cursor="pointer"
                          onClick={(e) => {
                            e.preventDefault();

                            db.collection("posts")
                              .doc(commentId)
                              .collection("comments")
                              .doc(id)
                              .delete()
                              .catch((error) => {
                                console.log(error.message);
                              });
                          }}
                          icon={faTrash}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              {/* eslint-disable-next-line */}
              <button
                className="btn"
                type="button"
                onClick={(e) => setComment(comment + e.target.value)}
                value="❤️"
              >
                ❤️
              </button>
              {/* eslint-disable-next-line */}
              <button
                className="btn"
                type="button"
                onClick={(e) => setComment(comment + e.target.value)}
                value="😀"
              >
                😀
              </button>
              {/* eslint-disable-next-line */}
              <button
                className="btn"
                type="button"
                onClick={(e) => setComment(comment + e.target.value)}
                value="🤣"
              >
                🤣
              </button>
              {/* eslint-disable-next-line */}
              <button
                className="btn"
                type="button"
                onClick={(e) => setComment(comment + e.target.value)}
                value="🥰"
              >
                🥰
              </button>
              {/* eslint-disable-next-line */}
              <button
                className="btn"
                type="button"
                onClick={(e) => setComment(comment + e.target.value)}
                value="😡"
              >
                😡
              </button>
              <form className="w-100">
                <div className="input-group mb-3">
                  <input
                    type="text"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    className="form-control"
                    placeholder="Enter a comment..."
                    aria-label="Enter a comment..."
                    aria-describedby="button-addon2"
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-primary"
                      type="submit"
                      onClick={postComment}
                      // id="button-addon2"
                      disabled={!auth?.currentUser?.emailVerified}
                    >
                      Send
                    </button>
                  </div>
                </div>
              </form>
              {auth?.currentUser?.emailVerified ? (
                ""
              ) : (
                <small id="passwordHelpBlock" className="form-text text-muted">
                  Login / verify your email to post comments
                </small>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <div
        className="modal fade "
        id="deleteDialog"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <p className="h5">Do you want to delete this post</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-primary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-danger" onClick={deletePost}>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default Post;
